export default {
    client: {
        id: import.meta.env.VUE_APP_CLIENT_ID,
        secret: import.meta.env.VUE_APP_CLIENT_SECRET,
    },
    options: {
        roles: [],
        redirects: {
            login: {
                name: "groups.index",
            },
            failed: {
                name: "auth.get-started",
            },
            success: {
                name: "groups.index",
            },
        },
        token: {
            header: "Authorization",
            type: "Bearer",
            url: "/oauth/token",
        },
        storageNames: {
            token: "sportspoule_token",
            refreshToken: "sportspoule_refresh_token",
            expiresAt: "sportspoule_expires_at",
        },
    },
};
